import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppConstant } from '../../../AppConstant'
import { setSelectedStudio, getAllStudioAsync, StudioDetails } from '../../../redux/flows/auth/studio/index'
import { useAppDispatch, useAppSelector } from '../../../redux/store'
import { APIStatus } from '../../../redux/types'

export function useStudioSetup() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const { allStudios, allStudiosStatus, allStudiosError, selectedStudio } = useAppSelector((state) => state.studioAuth)

  // Fetch all studios on mount
  useEffect(() => {
    if (allStudiosStatus === APIStatus.idle) {
      dispatch(getAllStudioAsync())
    }
  }, [dispatch, allStudiosStatus])

  // Handle studio selection
  const selectStudio = (studio: StudioDetails) => {
    dispatch(setSelectedStudio(studio))
    // Save to localStorage
    localStorage.setItem(AppConstant.STUDIO_DETAILS, JSON.stringify(studio))
    // Navigate to portal
    navigate('/current')
  }

  return {
    // Studio list
    allStudios,
    allStudiosStatus,
    allStudiosError,

    // Selected studio
    selectedStudio,

    // Actions
    selectStudio,
    navigate,
    dispatch,
  }
}
